import styled from 'styled-components';
import React from "react";
import useHost from "../../utils/host";
import AdUnit from "../feed_inserts/ad_unit";
import {useLoggedIn} from "../../store";
import {WhizzcoInfeedUnit} from "./WhizzcoInfeedUnit";

export const DynamicAd = styled(({className, prevAdTier, nextAdTier, expand, ... props}) => {

    const host = useHost();
    const community = props.community || "";

    const loggedIn = useLoggedIn();

/*    if (community.toLowerCase() !== 'all' && (host === "scored.co" || host === "m.scored.co" || ((host === "communities.win" || host === "m.communities.win") && !loggedIn)) && prevAdTier === 1 && nextAdTier === 1) {
        return <AdsenseInFeed expand={expand} />
    }*/

/*    if ((host === "communities.win" || host === "m.communities.win") && !loggedIn) {
        return <MgidAd />
    }*/

 /*   if ((host === "patriots.win" || host === "m.patriots.win") && !loggedIn) {
        return <DecideAd expand={expand}/>
        // return <RumbleAdUnit expand={expand} />
    }*/

/*    if (host === "patriots.win" && !loggedIn) {
        return <WhizzcoInfeedUnit expand={expand} />
    }*/

    return <AdUnit {...props} />

})``;

export default DynamicAd;
